import { createSlice } from "@reduxjs/toolkit";
import { DeviceRegistrationState } from "./deviceRegistration.types";
import deviceRegistrationCall from "./deviceRegistration.thunk";

const initialState: DeviceRegistrationState = {
  isDeviceRegisteringLoading: false
};

export const deviceRegistrationSlice = createSlice({
  name: "deviceRegistration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(deviceRegistrationCall.pending, (state) => {
      state.isDeviceRegisteringLoading = true
    })
    builder.addCase(deviceRegistrationCall.fulfilled, (state, action) => {
      state.isDeviceRegisteringLoading = false
    })
    builder.addCase(deviceRegistrationCall.rejected, (state, action) => {
      state.isDeviceRegisteringLoading = false
    })
  }
});

export const { } = deviceRegistrationSlice.actions;

export default deviceRegistrationSlice.reducer;